import React, { useState } from "react";
import { Autocomplete, Dialog, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModalActionsButtons } from "@/components/modal-actions-buttons";

export const CopyTimingsModal = ({
                                  open,
                                   allAvailableTimings,
                                  onSave,
                                  onCancel,
                                }: {
  open: boolean;
  allAvailableTimings: string[],
  onSave: (addableGameTypes: string[]) => void;
  onCancel: () => void;
}) => {

  const [selectedGameTypes, setSelectedGameTypes] = useState<string[]>([]);

  /*useEffect(() => {
    if (open && initialData) reset(initialData);
  }, [initialData, open, reset]);*/

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="lg" fullWidth>
      <DialogTitle>
        Choose Timings
        <IconButton onClick={onCancel} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 8 }}>
        <Autocomplete
          multiple
          options={allAvailableTimings}
          onChange={(event, newValues) => setSelectedGameTypes(newValues)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Timings"
              fullWidth
              style={{marginTop: 8}}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
        <ModalActionsButtons
          onCancelClick={onCancel}
          onConfirmClick={() => onSave(selectedGameTypes)}
        />
      </DialogContent>
    </Dialog>
  );
};